export default __webpack_public_path__ + "static/media/CuciStep1.ed6db0a9.png";